var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 1.44427L10.0703 0.881775C9.71875 0.811462 9.36719 0.975525 9.22656 1.30365L8.125 3.85834C8.00781 4.16302 8.07812 4.51459 8.33594 4.70209L9.60156 5.73334C8.80469 7.37396 7.49219 8.68646 5.85156 9.48334L4.82031 8.21771C4.63281 7.9599 4.28125 7.88959 3.97656 8.00677L1.42188 9.10834C1.11719 9.24896 0.929688 9.60052 1 9.92865L1.5625 12.2958C1.63281 12.624 1.91406 12.8583 2.26562 12.8583C8.17188 12.8583 13 8.07709 13 2.1474C13 1.79584 12.7656 1.51459 12.4141 1.44427ZM2.28906 12.1083L1.75 9.78802L4.25781 8.7099L5.66406 10.4208C8.07812 9.2724 9.39062 7.9599 10.5391 5.54584L8.82812 4.13959L9.90625 1.63177L12.2266 2.17084C12.2266 7.65521 7.77344 12.1083 2.28906 12.1083Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.14a4cd6d.svg";
export { ForwardRef as ReactComponent };